function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { notificationActions } from '../../../reducers/notification.reducer';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Input from '../../common/form/Input.react';
import Label from '../../common/form/Label.react';
import Select from '../../common/form/Select.react';
import Button from '../../common/Button.react';
import AzureBlob from '../../common/AzureBlob.react';
var UploadImage = function UploadImage(_ref) {
  var _ref$type = _ref.type,
    pType = _ref$type === void 0 ? 'image' : _ref$type,
    addToastAction = _ref.addToastAction,
    onUploaded = _ref.onUploaded,
    removeModalAction = _ref.removeModalAction,
    setAssetsAction = _ref.setAssetsAction,
    _ref$disableSelectIma = _ref.disableSelectImageType,
    disableSelectImageType = _ref$disableSelectIma === void 0 ? false : _ref$disableSelectIma;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var endpoint = useSelector(function (s) {
    return s.config.endpoints.cms.assets;
  });
  var _useState3 = useState({
      type: pType,
      file: null,
      title: '',
      asset: null,
      loading: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    form = _useState4[0],
    setForm = _useState4[1];
  var title = form.title,
    file = form.file,
    asset = form.asset,
    loading = form.loading,
    type = form.type;
  var blurObj = {
    image: true,
    icon: false,
    video: false,
    pageIndexContact: false,
    logo: false,
    silhouette: false
  };
  var typeDict = {
    image: 'Image',
    icon: 'Icon',
    video: 'Video',
    pageIndexContact: 'Section Contact Slide-out',
    logo: 'Logo',
    silhouette: 'Silhouette'
  };
  var lowResObj = {
    image: true,
    icon: false,
    video: false,
    pageIndexContact: false,
    logo: false,
    silhouette: false
  };
  var onChangeHandler = function onChangeHandler(e) {
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      file: e.target.files[0]
    }));
  };
  var onClickHandler = function onClickHandler() {
    var data = new FormData();
    data.append('original', file);
    data.append('type', type);
    data.append('blur', blurObj[type]);
    data.append('lowRes', lowResObj[type]);
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      loading: true
    }));
    axios.post(endpoint, data, {}).then(function (res) {
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        asset: res.data.assets[Object.keys(res.data.assets)],
        loading: false
      }));
      setAssetsAction(res.data.assets);
      onUploaded(res.data.assets[Object.keys(res.data.assets)]);
      addToastAction({
        message: 'File uploaded successfully!'
      });
    }).catch(function (err) {
      var data = err.response.data;
      var toastArr = Object.values(data.toast);
      for (var i = 0; i < toastArr.length; i++) addToastAction(toastArr[i]);
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        loading: false
      }));
    });
  };
  var isValid = function isValid() {
    return file !== null && !loading;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: asset ? 'Image Uploaded' : "Upload New ".concat(typeDict[type])
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body upload-image"
  }, !disableSelectImageType && /*#__PURE__*/React.createElement(Select, {
    value: type,
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        type: sValue
      }));
    },
    options: [{
      sValue: 'image',
      sLabel: 'Image'
    }, {
      sValue: 'pageIndexContact',
      sLabel: 'Section Contact Slide-out'
    }, {
      sValue: 'logo',
      sLabel: 'Logo'
    }]
  }), !file && /*#__PURE__*/React.createElement(Button, {
    label: "Select Image",
    onClick: function onClick() {
      $("#".concat(id)).click();
    },
    style: {
      width: '100%',
      marginBottom: 15
    }
  }), file && !asset && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onClickHandler();
    },
    label: "Upload",
    disabled: !isValid(),
    style: {
      width: '100%',
      marginBottom: 15
    }
  }), asset && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "upload-image__img"
  }, /*#__PURE__*/React.createElement(AzureBlob, {
    filename: "".concat(asset.filename)
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        title: e.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return removeModalAction();
    },
    label: "Close",
    type: "cancel",
    disabled: loading,
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    id: id,
    onChange: function onChange(e) {
      return onChangeHandler(e);
    },
    accept: "image/*",
    className: "hidden"
  })));
};
var mdtp = {
  addToastAction: notificationActions.addToast,
  removeModalAction: modalActions.remove,
  setAssetsAction: cmsActions.setAssets
};
export default connect(null, mdtp)(UploadImage);